import { Avatar, Button, CircularProgress, Divider, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import WsC from './providers/WsC';

import { ReactComponent as TrashAltSolid } from './Icoane Font Awesome/trash-alt-solid.svg'
import { ReactComponent as ChartBarSolid } from './Icoane Font Awesome/chart-bar-solid.svg'
import { ReactComponent as EyeSolid } from './Icoane Font Awesome/eye-solid.svg'
import AlertNew from '../../commons/dialogs/AlertNew';
import RaportChestionare from './RaportChestionare';
import RaportChestionareGeneral from './RaportChestionareGeneral';


export default class EvaluariGenerale extends SpecificComponent {
    constructor(props) {
        super(props);

        this.raportChestionareG = React.createRef()
        this.state = {
            sesiuni: [],
            sesiuniColegi: [],
            sesiuniSefi: [],
            sesiuniClienti: [],
            sesiuniAll: [],
            idColegi: '',
            idSefi: '',
            idClienti: '',
            chestionare: [],
            popUpSalvare: true,
            popUpGenerala: true,
            combinaEvaluari: false,
            idChestionar: null,
            readySesiuneNoua: false,
            checkRaport: false,
            angajatiSelectati: 0,
            sesiuneSelectata: null,
            intrebari: [],
            raport: { id: null, raport_data: { evaluari: [], intrebari: [], departamente: [], acelasi_chestionar: true, sesiune: { sub_sesiuni: [] } } },
            openDeleteEvaluare: false,
            openDeleteRaport: false,
            openRaport: false,
            evaluareSelectata: {},
            userEvaluat: {
                id: null, poza: null
            },
            useri: [],
            sesiuneSelectataRaport: {},
            utilizatoriSelectati: [],
            loading: true,
            titluSesiuneColegi: '',
            titluSesiuneManager: '',
            titluSesiuneClienti: '',
            titluSesiuneGenerala: '',
            sesiuneNoua: false,
            openDeleteSesiune: false,
            sesiuneToDelete: {},
            evaluariAll: [],
            optiuniRaspunsAll: [],
            alertView: false

        }
    }


    u = new Utils()
    ws = new WsC()
    wsP = new Ws()
    ls = new LocalStorage().GetUserData()

    componentDidMount() {
        this.access()
        this.getSesiuni()
    }

    access = async () => {



        // console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    getIntrebari = async (ses) => {

        this.setState({ loading: true }, async () => {

        let _raspunsuri = this.ws.customSelect(`select r.*, h.id_evaluare from raspunsuri_intrebari r left join raspunsuri_head h on r.id_head = h.id
                where h.id_evaluare in (select id from evaluari where id_sesiune = @p1 and isnull(inactiv,0) != 1) order by isnull(ordinea,0) asc, id`, {
            p1: ses.id


        })


        let _optiuniRaspuns = this.ws.customSelect(`select r.*, h.id_evaluare, h.statusul from raspunsuri_intrebari_raspunsuri r left join raspunsuri_head h on r.id_head = h.id 
            where h.id_evaluare in (select id from evaluari where id_sesiune = @p1 and isnull(inactiv,0) != 1) order by r.id_optiune_raspuns asc`, {
            p1: ses.id
        })


        let [raspunsuri, optiuniRaspuns] = await Promise.all([_raspunsuri, _optiuniRaspuns])

        if (raspunsuri.Succes && optiuniRaspuns.Succes) {
            let intrebari = [...raspunsuri.Content]
            let optiuniR = [...optiuniRaspuns.Content]



            let intrebariNew = []


            for (let k = 0, l = intrebari.length; k < l; k++) {





                let filterRaspunsuri = optiuniR.filter(ras => Number(ras.id_head) === Number(intrebari[k].id_head))
                filterRaspunsuri = filterRaspunsuri.filter(ras => Number(ras.id_intrebare) === Number(intrebari[k].id_intrebare))

                intrebari[k].raspunsuri = filterRaspunsuri

                intrebariNew.push(intrebari[k])



            }


     
              await  this.creeazaRaport(ses, intrebari)
            
        }
    })



    }




    getSesiuni = async () => {

        // let updateSesiuni = await this.ws.update('sesiuni', {sters:1} , {id:104} )


        let q = `select s.*, (select count(*) from raspunsuri_head where id_evaluare in (select id from evaluari where id_sesiune = s.id and isnull(inactiv,0) != 1)) as completari_toate,
                             (select count(*) from raspunsuri_head where id_evaluare in (select id from evaluari where id_sesiune = s.id and isnull(inactiv,0) != 1) and statusul = @p1) as completari_finalizate 
                             from sesiuni s where isnull(s.sters,0) != 1 and s.tip = @p2 and s.baza_date = @p3 order by s.id asc`

        let qAll = `select s.*, (select count(*) from raspunsuri_head where id_evaluare in (select id from evaluari where id_sesiune = s.id and isnull(inactiv,0) != 1)) as completari_toate,
        (select count(*) from raspunsuri_head where id_evaluare in (select id from evaluari where id_sesiune = s.id and isnull(inactiv,0) != 1) and statusul = @p1) as completari_finalizate 
        from sesiuni s where isnull(s.sters,0) != 1 and s.baza_date = @p2 order by s.id asc`


        let _getSesiuni = this.ws.customSelect(q, { p1: 'Finalizat', p2: 'evaluare_generala', p3: this.ls.InfoUser.Database })

        let _getSesiuniAll = this.ws.customSelect(qAll, { p1: 'Finalizat', p2: this.ls.InfoUser.Database })

        let _chestionare = this.ws.customSelect(`select u.nume as nume_utilizator,  c.* , (select count(*) from chestionare_intrebari where id_chestionar = c.id and isnull(id_parent,0) = 0) as nr_intrebari 
                                                    from chestionare c left join [${this.ls.InfoUser.Database}].[dbo].[useri] u on c.creat_de = u.id  where c.baza_date = @p1 and isnull(c.sters,0) != 1`,
            {
                p1: this.ls.InfoUser.Database,
            })

        let _evaluari = this.ws.customSelect(`select e.*, a.poza, a.functie, a.nume as nume, (select count(*) from raspunsuri_head where id_evaluare = e.id and statusul = @p1) as completari_finalizate, 
                                                         (select count(*) from raspunsuri_head where id_evaluare = e.id ) as completari_toate
                                            from evaluari e left join [${this.ls.InfoUser.Database}].[dbo].[angajati] a on a.id_user = e.id_user_aprobare
                                             where e.id_sesiune in (select id from sesiuni where isnull(id_parent,0) != 0) and isnull(e.inactiv,0) != 1 ` , {
            p1: 'Finalizat'
        })
        let _departamente = this.wsP.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, { p1: 1 })



        // let _raspunsuri = this.ws.customSelect(`select r.*, h.id_evaluare from raspunsuri_intrebari r left join raspunsuri_head h on r.id_head = h.id
        //                                     where h.id_evaluare in (select id from evaluari where id_sesiune in (select id from sesiuni where isnull(id_parent,0) != 0) and isnull(inactiv,0) != 1) order by isnull(ordinea,0) asc, id`, {
        //     p1: this.props.match.params.idsesiune
        // })

        // let _raspunsuri = this.ws.customSelect(`select r.* from raspunsuri_intrebari r left join raspunsuri_head h on r.id_head = h.id
        //                                         where h.id_evaluare = 1233 ` , {p1:1})

        let _optiuniRaspuns = this.ws.customSelect(`select r.*, h.id_evaluare, h.statusul from raspunsuri_intrebari_raspunsuri r left join raspunsuri_head h on r.id_head = h.id 
                                                    where h.id_evaluare in (select id from evaluari where id_sesiune in (select id from sesiuni where isnull(id_parent, 0) != 0 ) and isnull(inactiv,0) != 1) order by r.id_optiune_raspuns asc`, {
            p1: this.props.match.params.idsesiune
        })

        let _rapoarte = this.ws.customSelect(`select * from rapoarte_salvate_head where id_sesiune in (select id from sesiuni where tip = @p1) and isnull(sters,0) != 1`, { p1: 'evaluare_generala' })

        let [getSesiuni, getSesiuniAll, chestionare, e, departamente,  optiuniRaspuns, rapoarte] = await Promise.all([_getSesiuni, _getSesiuniAll, _chestionare, _evaluari, _departamente,  _optiuniRaspuns, _rapoarte])


        // console.log('evaluari :>> ', e);

        if (getSesiuni.Succes && chestionare.Succes && getSesiuniAll.Succes && e.Succes && departamente.Succes && optiuniRaspuns.Succes && rapoarte.Succes) {

            let sesiuni = [...getSesiuni.Content]

            // console.log('sesiuni :>> ', sesiuni);

            let sesiuniAll = [...getSesiuniAll.Content]

            let depart = [...departamente.Content]
            let evaluari = [...e.Content]
            let optiuniR = [...optiuniRaspuns.Content]
            // let intrebari = [...raspunsuri.Content]
            let rap = [...rapoarte.Content]

            // console.log('rapoarte :>> ', rapoarte);

            // console.log('departamente :>> ', departamente);
            // console.log('depart :>> ', depart);
            // console.log('sesiuniAll :>> ', getSesiuniAll);
            // console.log('intrebari :>> ', intrebari);


            for (let i = 0, n = sesiuniAll.length; i < n; i++) {
                sesiuniAll[i].procent_completare = Math.floor(((sesiuniAll[i].completari_finalizate * 100) / sesiuniAll[i].completari_toate) || 0)

                sesiuniAll[i].color = sesiuniAll[i].procent_completare >= 80 ? 'rgb(24 165 58)' : (sesiuniAll[i].procent_completare < 80 && sesiuniAll[i].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
            }

            for (let i = 0, n = sesiuni.length; i < n; i++) {

                sesiuni[i].procent_completare = Math.floor(((sesiuni[i].completari_finalizate * 100) / sesiuni[i].completari_toate) || 0)

                sesiuni[i].color = sesiuni[i].procent_completare >= 80 ? 'rgb(24 165 58)' : (sesiuni[i].procent_completare < 80 && sesiuni[i].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')


                sesiuni[i].sub_sesiuni = sesiuniAll.filter(s => s.id_parent === sesiuni[i].id)

                sesiuni[i].acelasi_chestionar = true

                sesiuni[i].pop_up = false


                let subSesiuniSame = sesiuni[i].sub_sesiuni.filter(ses => ses.id_chestionar === sesiuni[i].sub_sesiuni[0].id_chestionar)

                if (subSesiuniSame.length !== sesiuni[i].sub_sesiuni.length) {
                    sesiuni[i].acelasi_chestionar = false
                    sesiuni[i].pop_up = true
                }


                for (let k = 0, o = sesiuni[i].sub_sesiuni.length; k < o; k++) {

                    sesiuni[i].sub_sesiuni[k].evaluari = []

                    sesiuni[i].sub_sesiuni[k].puncte = 0

                    // console.log('sesiuni[i].sub_sesiuni[k] :>> ', sesiuni[i].sub_sesiuni[k].id);
                    let filterE = evaluari.filter(eva => eva.id_sesiune === sesiuni[i].sub_sesiuni[k].id)



                    // console.log('filterE :>> ', filterE);

                    sesiuni[i].sub_sesiuni[k].punctaj_maxim = 0

                    let punctajMaxim = punctajMaxim / evaluari.length

                    let dep = JSON.parse(JSON.stringify(depart))


                    for (let l = 0, p = dep.length; l < p; l++) {
                        dep[l]['evaluari'] = []

                        let filterEdep = filterE.filter(eva => eva.id_departament === dep[l].id)


                        // console.log('filterEdep :>> ', filterEdep);


                        if (filterEdep.length > 0) {


                            for (let j = 0, m = filterEdep.length; j < m; j++) {
                                let pct = 0








                                let filterR = optiuniR.filter(o => o.id_evaluare === filterEdep[j].id)

                                if (filterR.length > 0) {
                                    for (let b = 0, v = filterR.length; b < v; b++) {

                                        sesiuni[i].sub_sesiuni[k].punctaj_maxim += filterR[b].puncte || 0




                                        pct += filterR[b].raspuns ? filterR[b].puncte : 0 || 0
                                    }


                                    filterEdep[j].puncte = pct

                                    sesiuni[i].sub_sesiuni[k].puncte += pct
                                }

                                filterEdep[j].procent_completare = Math.floor(((filterEdep[j].completari_finalizate * 100) / filterEdep[j].completari_toate) || 0)

                                filterEdep[j].color = filterEdep[j].procent_completare >= 80 ? 'rgb(24 165 58)' : (filterEdep[j].procent_completare < 80 && filterEdep[j].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                                filterEdep[j].color_puncte = filterEdep[j].puncte >= (punctajMaxim - (punctajMaxim / 3)) ? 'rgb(24 165 58)' : (filterEdep[j].puncte < (punctajMaxim - (punctajMaxim / 3)) && filterEdep[j].puncte >= (punctajMaxim / 2) ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                                filterEdep[j].checked = false
                                filterEdep[j].raspunsuri = filterR


                                dep[l]['evaluari'].push(filterEdep[j])
                            }




                            dep[l]['checked'] = false

                            sesiuni[i].sub_sesiuni[k].evaluari.push(dep[l])

                            // console.log('dep[l] :>> ', dep[l]);
                        }
                    }

                }


                sesiuni[i].rapoarte = rap.filter(r => r.id_sesiune === sesiuni[i].id)


            }


            // console.log('sesiuni :>> ', sesiuni);

            let sesiuniColegi = sesiuniAll.filter(s => s.tip === 'evaluare_angajati')

            let sesiuniSefi = sesiuniAll.filter(s => s.tip === 'evaluare_sefi')

            let sesiuniClienti = sesiuniAll.filter(s => s.tip === 'evaluare_clienti')



            // let intrebariNew = []


            // for (let k = 0, l = intrebari.length; k < l; k++) {





            //     let filterRaspunsuri = optiuniR.filter(ras => Number(ras.id_head) === Number(intrebari[k].id_head))
            //     filterRaspunsuri = filterRaspunsuri.filter(ras => Number(ras.id_intrebare) === Number(intrebari[k].id_intrebare))

            //     intrebari[k].raspunsuri = filterRaspunsuri

            //     intrebariNew.push(intrebari[k])



            // }

            this.setState({
                sesiuni: sesiuni,
                chestionare: chestionare.Content,
                sesiuniColegi: sesiuniColegi,
                sesiuniSefi: sesiuniSefi,
                sesiuniClienti: sesiuniClienti,
                popUpSalvare: chestionare.Content.length > 0 ? false : true,
                sesiuniAll: sesiuniAll,
                readySesiuneNoua: false,
                combinaEvaluari: false,
                // intrebari: intrebariNew,
                checkRaport: false,
                sesiuneSelectata: null,
                departamente: depart,
                evaluariAll: evaluari,
                optiuniRaspunsAll: optiuniR,
                loading: false

            })
        }

        // console.log('getSesiuni :>> ', getSesiuni);
    }



    getRapoarte = async () => {

        let rapoarte = await this.ws.customSelect(`select * from rapoarte_salvate_head where id_sesiune in (select id from sesiuni where tip = @p1) and isnull(sters,0) != 1`, { p1: 'evaluare_generala' })


        if (rapoarte.Succes) {


            let sesiuni = [...this.state.sesiuni]

            // console.log('sesiuni :>> ', sesiuni);

            let sesiuniAll = [...this.state.sesiuniAll]

            let depart = [...this.state.departamente]
            let evaluari = [...this.state.evaluariAll]
            let optiuniR = [...this.state.optiuniRaspunsAll]
            let rap = [...rapoarte.Content]

            // console.log('rapoarte :>> ', rapoarte);



            for (let i = 0, n = sesiuniAll.length; i < n; i++) {
                sesiuniAll[i].procent_completare = Math.floor(((sesiuniAll[i].completari_finalizate * 100) / sesiuniAll[i].completari_toate) || 0)

                sesiuniAll[i].color = sesiuniAll[i].procent_completare >= 80 ? 'rgb(24 165 58)' : (sesiuniAll[i].procent_completare < 80 && sesiuniAll[i].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
            }

            for (let i = 0, n = sesiuni.length; i < n; i++) {

                sesiuni[i].procent_completare = Math.floor(((sesiuni[i].completari_finalizate * 100) / sesiuni[i].completari_toate) || 0)

                sesiuni[i].color = sesiuni[i].procent_completare >= 80 ? 'rgb(24 165 58)' : (sesiuni[i].procent_completare < 80 && sesiuni[i].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')


                sesiuni[i].sub_sesiuni = sesiuniAll.filter(s => s.id_parent === sesiuni[i].id)

                sesiuni[i].acelasi_chestionar = true

                sesiuni[i].pop_up = false


                let subSesiuniSame = sesiuni[i].sub_sesiuni.filter(ses => ses.id_chestionar === sesiuni[i].sub_sesiuni[0].id_chestionar)

                if (subSesiuniSame.length !== sesiuni[i].sub_sesiuni.length) {
                    sesiuni[i].acelasi_chestionar = false
                    sesiuni[i].pop_up = true
                }


                for (let k = 0, o = sesiuni[i].sub_sesiuni.length; k < o; k++) {

                    sesiuni[i].sub_sesiuni[k].evaluari = []

                    sesiuni[i].sub_sesiuni[k].puncte = 0

                    // console.log('sesiuni[i].sub_sesiuni[k] :>> ', sesiuni[i].sub_sesiuni[k].id);
                    let filterE = evaluari.filter(eva => eva.id_sesiune === sesiuni[i].sub_sesiuni[k].id)



                    // console.log('filterE :>> ', filterE);

                    sesiuni[i].sub_sesiuni[k].punctaj_maxim = 0

                    let punctajMaxim = punctajMaxim / evaluari.length

                    let dep = JSON.parse(JSON.stringify(depart))


                    for (let l = 0, p = dep.length; l < p; l++) {
                        dep[l]['evaluari'] = []

                        let filterEdep = filterE.filter(eva => eva.id_departament === dep[l].id)


                        // console.log('filterEdep :>> ', filterEdep);


                        if (filterEdep.length > 0) {


                            for (let j = 0, m = filterEdep.length; j < m; j++) {
                                let pct = 0








                                let filterR = optiuniR.filter(o => o.id_evaluare === filterEdep[j].id)

                                if (filterR.length > 0) {
                                    for (let b = 0, v = filterR.length; b < v; b++) {

                                        sesiuni[i].sub_sesiuni[k].punctaj_maxim += filterR[b].puncte || 0




                                        pct += filterR[b].raspuns ? filterR[b].puncte : 0 || 0
                                    }


                                    filterEdep[j].puncte = pct

                                    sesiuni[i].sub_sesiuni[k].puncte += pct
                                }

                                filterEdep[j].procent_completare = Math.floor(((filterEdep[j].completari_finalizate * 100) / filterEdep[j].completari_toate) || 0)

                                filterEdep[j].color = filterEdep[j].procent_completare >= 80 ? 'rgb(24 165 58)' : (filterEdep[j].procent_completare < 80 && filterEdep[j].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                                filterEdep[j].color_puncte = filterEdep[j].puncte >= (punctajMaxim - (punctajMaxim / 3)) ? 'rgb(24 165 58)' : (filterEdep[j].puncte < (punctajMaxim - (punctajMaxim / 3)) && filterEdep[j].puncte >= (punctajMaxim / 2) ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                                filterEdep[j].checked = false
                                filterEdep[j].raspunsuri = filterR


                                dep[l]['evaluari'].push(filterEdep[j])
                            }




                            dep[l]['checked'] = false

                            sesiuni[i].sub_sesiuni[k].evaluari.push(dep[l])

                            // console.log('dep[l] :>> ', dep[l]);
                        }
                    }

                }


                sesiuni[i].rapoarte = rap.filter(r => r.id_sesiune === sesiuni[i].id)


            }


            // console.log('sesiuni :>> ', sesiuni);

            let sesiuniColegi = sesiuniAll.filter(s => s.tip === 'evaluare_angajati')

            let sesiuniSefi = sesiuniAll.filter(s => s.tip === 'evaluare_sefi')

            let sesiuniClienti = sesiuniAll.filter(s => s.tip === 'evaluare_clienti')




            this.setState({
                sesiuni: sesiuni,
                sesiuniColegi: sesiuniColegi,
                sesiuniSefi: sesiuniSefi,
                sesiuniClienti: sesiuniClienti,
                sesiuniAll: sesiuniAll,
                readySesiuneNoua: false,
                combinaEvaluari: false,
                checkRaport: false,
                sesiuneSelectata: null,
                departamente: depart
            })
        }


    }


    returnButton = () => {
        let rez = []




        rez.push(<div key={1}>
            <Button className='add-button-green' style={{ display: this.props.displayInsert === 1 ? 'none' : 'inline-flex' }} onClick={() => { this.setState({ sesiuneNoua: true }) }}   >
                <i className='material-icons pm-round-button-text'>add</i>
                {this.dictionary.evaluari.sesiuneNoua}
            </Button>
        </div>)




        return rez
    }


    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>{this.dictionary.evaluari.astazi}:{this.dataAzi()} </span>
        </div>)

        return rez
    }


    dataAzi = () => {


        let dataAzi = this.u.defaultData()

        if (this.dictionary.date === 'en') {
            return this.u.dataPrescurtataEng(dataAzi)
        } else {
            return this.u.dataPrescurtataRomana(dataAzi)
        }
    }


    addSesiune = async () => {

        let data = new Date()

        let luna = this.u.luni[data.getMonth()]

        let an = data.getFullYear()



        let objToInsert = {
            nume: this.state.titluSesiuneGenerala,
            tip: 'evaluare_generala',
            baza_date: this.ls.InfoUser.Database

        }

        let insertSesiune = await this.ws.insert('sesiuni', objToInsert)

        if (insertSesiune.Succes) {
            // console.log('insertSesiune :>> ', insertSesiune);



            let sesiuneColegi = {
                nume: this.state.titluSesiuneColegi,
                tip: 'evaluare_angajati',
                baza_date: this.ls.InfoUser.Database,
                id_parent: insertSesiune.Content[0].id

            }

            let sesiuneSefi = {
                nume: this.state.titluSesiuneManager,
                tip: 'evaluare_sefi',
                baza_date: this.ls.InfoUser.Database,
                id_parent: insertSesiune.Content[0].id

            }

            let sesiuneClienti = {
                nume: this.state.titluSesiuneClienti,
                tip: 'evaluare_clienti',
                baza_date: this.ls.InfoUser.Database,
                id_parent: insertSesiune.Content[0].id

            }

            let isesiuneColegi = await this.ws.insert('sesiuni', sesiuneColegi)


            if (isesiuneColegi.Succes) {

                let isesiuneSefi = await this.ws.insert('sesiuni', sesiuneSefi)

                if (isesiuneSefi.Succes) {
                    let isesiuneClienti = await this.ws.insert('sesiuni', sesiuneClienti)

                    if (isesiuneClienti.Succes) {

                        this.props.history.push(`/evaluarenouagenerala/${isesiuneColegi.Content[0].id}/${isesiuneSefi.Content[0].id}/${isesiuneClienti.Content[0].id}`)
                    }
                }

            }
        }

    }


    goToSesiune = (s) => {
        this.props.history.push(`/evaluarisesiune/${s.id}/${s.tip}`)
    }



    combinaEvaluari = () => {
        this.setState({ combinaEvaluari: true })
    }

    backCombinaEvaluari = () => {
        this.setState({
            combinaEvaluari: false,
            idColegi: '',
            idSefi: '',
            idClienti: '',

        })
    }

    changeSesiuneColegi = (ev) => {

        let val = ev.target.value

        let idxChestionar = this.state.sesiuniColegi.findIndex(s => Number(s.id) === Number(val))


        if (idxChestionar !== -1) {


            let idChestionar = this.state.sesiuniColegi[idxChestionar].id_chestionar






            let readySesiuneNoua = this.state.readySesiuneNoua

            if (Number(this.state.idSefi) > 0 && Number(this.state.idClienti) > 0) {
                readySesiuneNoua = true
            }
            this.setState({
                idColegi: val,
                readySesiuneNoua: readySesiuneNoua,
            })

        }

    }

    changeSesiuneSefi = (ev) => {
        let val = ev.target.value

        let idxChestionar = this.state.sesiuniSefi.findIndex(s => Number(s.id) === Number(val))


        if (idxChestionar !== -1) {


            let idChestionar = this.state.sesiuniSefi[idxChestionar].id_chestionar


            let sesiuniAll = [...this.state.sesiuniAll]




            let readySesiuneNoua = this.state.readySesiuneNoua

            if (Number(this.state.idColegi) > 0 && Number(this.state.idClienti) > 0) {
                readySesiuneNoua = true
            }

            this.setState({
                idSefi: val,

                readySesiuneNoua: readySesiuneNoua,

            })

        }
    }

    changeSesiuneClienti = (ev) => {
        let val = ev.target.value

        let idxChestionar = this.state.sesiuniClienti.findIndex(s => Number(s.id) === Number(val))


        if (idxChestionar !== -1) {


            let idChestionar = this.state.sesiuniClienti[idxChestionar].id_chestionar


            let sesiuniAll = [...this.state.sesiuniAll]


            let sesiuniAllFilter = sesiuniAll.filter(s => Number(s.id_chestionar) === Number(idChestionar))




            let readySesiuneNoua = this.state.readySesiuneNoua

            if (Number(this.state.idColegi) > 0 && Number(this.state.idSefi) > 0) {
                readySesiuneNoua = true
            }

            this.setState({
                idClienti: val,
                readySesiuneNoua: readySesiuneNoua,
            })

        }
    }


    addSesiuneCombinata = async () => {

        console.log('idClienti :>> ', this.state.idClienti);
        console.log('idSefi :>> ', this.state.idSefi);
        console.log('idColegi :>> ', this.state.idColegi);


        let data = new Date()

        let luna = this.u.luni[data.getMonth()]

        let an = data.getFullYear()



        let objToInsert = {
            nume: `${luna} ${an}`,
            tip: 'evaluare_generala',
            baza_date: this.ls.InfoUser.Database

        }

        let insertSesiune = await this.ws.insert('sesiuni', objToInsert)

        if (insertSesiune.Succes) {
            console.log('insertSesiune :>> ', insertSesiune);



            let sesiuneColegi = {
                id_parent: insertSesiune.Content[0].id

            }

            let sesiuneSefi = {
                id_parent: insertSesiune.Content[0].id

            }

            let sesiuneClienti = {
                id_parent: insertSesiune.Content[0].id

            }

            let isesiuneColegi = this.ws.update('sesiuni', sesiuneColegi, { id: this.state.idColegi })
            let isesiuneSefi = this.ws.update('sesiuni', sesiuneSefi, { id: this.state.idSefi })
            let isesiuneClienti = this.ws.update('sesiuni', sesiuneClienti, { id: this.state.idClienti })


            let [sCo, sCs, sCc] = await Promise.all([isesiuneColegi, isesiuneSefi, isesiuneClienti])


            if (sCo.Succes && sCs.Succes && sCc.Succes) {

                this.getSesiuni()
            }
        }
    }




    creeazaRaport = async (ses, intreb) => {

        this.setState({ loading: true }, async () => {
            let intrebari = JSON.parse(JSON.stringify(intreb))

            // console.log('intrebari :>> ', intrebari);

            // let intrebariFilter =intrebari.filter(intr => Number(intr.id_evaluare) === 1233)

            // console.log('intrebariFilter :>> ', intrebariFilter);

            let intrebariClone = []

            let sesiuni = { ...ses }

            let departamente = JSON.parse(JSON.stringify(this.state.departamente))

            let evaluari = []

            // console.log('ses :>> ', ses);

            if (ses.acelasi_chestionar) {

                // console.warn('sesiuneSelectata acelasi chestionar :>> ', ses);
                for (let s = 0, h = sesiuni.sub_sesiuni.length; s < h; s++) {

                    for (let k = 0, q = sesiuni.sub_sesiuni[s].evaluari.length; k < q; k++) {

                        for (let p = 0, o = sesiuni.sub_sesiuni[s].evaluari[k].evaluari.length; p < o; p++) {


                            evaluari.push(sesiuni.sub_sesiuni[s].evaluari[k].evaluari[p])



                        }
                    }

                }

                // console.log('sesiuni :>> ', sesiuni);

                let evaluariClone = JSON.parse(JSON.stringify(evaluari))
                // console.log('evaluariClone :>> ', evaluariClone);


                for (let i = 0, n = evaluariClone.length; i < n; i++) {

                    let intrebariEv = intrebari.filter(fi => fi.id_evaluare === evaluariClone[i].id)

                    // console.log('intrebariEv :>> ', intrebariEv);

                    for (let j = 0, n = intrebariEv.length; j < n; j++) {
                        let idx = intrebariClone.findIndex(intr => Number(intr.id_intrebare) === Number(intrebariEv[j].id_intrebare))

                        if (idx === -1) {
                            intrebariClone.push(intrebariEv[j])
                        }
                    }


                }

                // console.warn('intrebariClone :>> ', intrebariClone);

                let evaluariUniqueTip = []

                for (let i = 0, n = evaluariClone.length; i < n; i++) {

                    // if (evaluariClone[i].checked) {
                    if (evaluariUniqueTip.length > 0) {

                        let idx = evaluariUniqueTip.findIndex(evl => evl.id_user_aprobare === evaluariClone[i].id_user_aprobare && evl.tip === evaluariClone[i].tip)

                        if (idx !== -1) {



                            evaluariUniqueTip[idx].completari_finalizate = evaluariUniqueTip[idx].completari_finalizate + evaluariClone[i].completari_finalizate
                            evaluariUniqueTip[idx].completari_toate = evaluariUniqueTip[idx].completari_toate + evaluariClone[i].completari_toate

                            for (let j = 0, m = evaluariClone[i].raspunsuri.length; j < m; j++) {
                                evaluariUniqueTip[idx].raspunsuri.push(evaluariClone[i].raspunsuri[j])



                            }





                        } else {
                            evaluariUniqueTip.push(evaluariClone[i])
                        }

                    } else {
                        evaluariUniqueTip.push(evaluariClone[i])
                    }
                    // }



                }


                let evaluariUnique = []

                for (let i = 0, n = evaluariClone.length; i < n; i++) {

                    // if (evaluariClone[i].checked) {
                    if (evaluariUnique.length > 0) {

                        let idx = evaluariUnique.findIndex(evl => evl.id_user_aprobare == evaluariClone[i].id_user_aprobare)

                        if (idx === -1) {



                            evaluariUnique.push(evaluariClone[i])
                        }

                    } else {
                        evaluariUnique.push(evaluariClone[i])
                    }
                    // }



                }

                let userEvaluat = this.state.userEvaluat.id ? this.state.userEvaluat : { id: evaluariUnique[0].id_user_aprobare, poza: evaluariUnique[0].poza, nume: evaluariUnique[0].nume }


                for (let i = 0, n = departamente.length; i < n; i++) {

                    departamente[i].angajati = []

                    let filterUseri = evaluariUnique.filter(dep => dep.id_departament === departamente[i].id)




                    for (let j = 0, m = filterUseri.length; j < m; j++) {
                        filterUseri[j].selectat = false

                        departamente[i].angajati.push(filterUseri[j])
                    }


                    departamente[i].selectat = false




                }


                departamente = departamente.filter(dep => dep.angajati.length > 0)

                // console.log('departamente :>> ', departamente);

                // console.log('evaluariClone :>> ', evaluariClone);

                // console.log('evvaluariUnique :>> ', evaluariUnique);




                let raportData = { completare: sesiuni.procent_completare, evaluari: evaluariUniqueTip, completare_color: sesiuni.color, sesiune: sesiuni, intrebari: intrebariClone, departamente: departamente, acelasi_chestionar: true, utilizatoriSelectati: this.state.utilizatoriSelectati }

                // console.log('raportData :>> ', raportData);
                let raport = {
                    id_sesiune: sesiuni.id,
                    titlu: '',
                    la_data: this.u.updateSqlNow(),
                    nr_evaluari: evaluariClone.length,
                    finalizat_la_creare: sesiuni.finalizat === 1 ? 1 : 0,
                    raport_data: JSON.stringify(raportData),


                }



                let insertRaport = await this.ws.insert('rapoarte_salvate_head', raport)

                // console.log('insertRaport :>> ', insertRaport);

                if (insertRaport.Succes) {



                    raport.raport_data = JSON.parse(raport.raport_data)
                    raport.id = insertRaport.Content[0].id

                    this.setState({
                        checkRaport: false,
                        popUpRaport: false,
                        openRaport: true,
                        raport: raport,
                        sesiuneSelectata: null,
                        sesiuneSelectataRaport: ses,
                        useri: evaluariUnique,
                        userEvaluat: userEvaluat,
                        utilizatoriSelectati: [],
                        loading: false
                    }, () => {
                        this.getSesiuni()
                        this.raportChestionareG.current.filterRaport()
                    })

                }

            } else {

                let raportData = { completare: sesiuni.procent_completare, completare_color: sesiuni.color, sesiune: sesiuni, acelasi_chestionar: false }

                let raport = {
                    id_sesiune: sesiuni.id,
                    titlu: '',
                    la_data: this.u.updateSqlNow(),
                    nr_evaluari: sesiuni.sub_sesiuni.length,
                    finalizat_la_creare: sesiuni.finalizat === 1 ? 1 : 0,
                    raport_data: JSON.stringify(raportData),


                }

                let insertRaport = await this.ws.insert('rapoarte_salvate_head', raport)

                // console.log('insertRaport :>> ', insertRaport);

                if (insertRaport.Succes) {



                    raport.raport_data = JSON.parse(raport.raport_data)
                    raport.id = insertRaport.Content[0].id

                    this.setState({
                        checkRaport: false,
                        popUpRaport: false,
                        openRaport: true,
                        raport: raport,
                        sesiuneSelectata: null,
                        sesiuneSelectataRaport: ses,
                        loading: false
                    }, () => {
                        this.getRapoarte()

                    })

                }
            }


        })










    }


    // creeazaRaport = async (s) => {
    //     // if (this.state.checkRaport) {

    //         let intrebari = JSON.parse(JSON.stringify(this.state.intrebari))


    //         console.log('s :>> ', s);

    //         let sesiuni = { ...s}

    //         let evaluari = []


    //         console.log('sesiuni :>> ', sesiuni);

    //         for (let s = 0, h = sesiuni.sub_sesiuni.length; s < h; s++) {

    //             for (let k = 0, q = sesiuni.sub_sesiuni[s].evaluari.length; k < q; k++) {

    //                 for (let p = 0, o = sesiuni.sub_sesiuni[s].evaluari[k].evaluari.length; p < o; p++) {


    //                     evaluari.push(sesiuni.sub_sesiuni[s].evaluari[k].evaluari[p])



    //                 }
    //             }

    //         }




    //         let evaluariCLone = JSON.parse(JSON.stringify(evaluari))

    //         console.log('evaluariClone :>> ', evaluariCLone);

    //         let evaluariUnique = []

    //         for (let i = 0, n = evaluariCLone.length; i < n; i++) {

    //             // if (evaluariCLone[i].checked) {
    //                 if (evaluariUnique.length > 0) {

    //                     let idx = evaluariUnique.findIndex(evl => evl.id_user_aprobare == evaluariCLone[i].id_user_aprobare)

    //                     if (idx !== -1) {

    //                         // if(evaluariUnique[idx].)


    //                         evaluariUnique[idx].completari_finalizate = evaluariUnique[idx].completari_finalizate + evaluariCLone[i].completari_finalizate
    //                         evaluariUnique[idx].completari_toate = evaluariUnique[idx].completari_toate + evaluariCLone[i].completari_toate

    //                         for (let j = 0, m = evaluariCLone[i].raspunsuri.length; j < m; j++) {
    //                             evaluariUnique[idx].raspunsuri.push(evaluariCLone[i].raspunsuri[j])



    //                         }
    //                     } else {
    //                         evaluariUnique.push(evaluariCLone[i])
    //                     }

    //                 } else {
    //                     evaluariUnique.push(evaluariCLone[i])
    //                 }
    //             // }



    //         }

    //         console.log('evaluariUnique :>> ', evaluariUnique);

    //         for (let i = 0, n = intrebari.length; i < n; i++) {


    //             for (let j = 0, m = intrebari[i].raspunsuri.length; j < m; j++) {

    //                 intrebari[i].raspunsuri[j].rezultate = []
    //                 intrebari[i].raspunsuri[j].rezultate_evaluare = []

    //                 let sumaRaspuns = 0

    //                 for (let k = 0, o = evaluariUnique.length; k < o; k++) {


    //                     let filterRaspunsuriOptiuneRaspuns = evaluariUnique[k].raspunsuri.filter(rasp => rasp.id_optiune_raspuns === intrebari[i].raspunsuri[j].id_optiune_raspuns)

    //                     filterRaspunsuriOptiuneRaspuns = filterRaspunsuriOptiuneRaspuns.filter(rasp => rasp.raspuns !== null)
    //                     sumaRaspuns = Math.floor(((filterRaspunsuriOptiuneRaspuns.length * 100) / evaluariUnique[k].completari_finalizate) || 0)
    //                     console.log('filterRaspunsuriOptiuneRaspuns :>> ', filterRaspunsuriOptiuneRaspuns);
    //                     console.log('sumaRaspuns :>> ', sumaRaspuns);
    //                     intrebari[i].raspunsuri[j].rezultate.push(sumaRaspuns)
    //                     console.log('evaluariUnique[k] :>> ', evaluariUnique[k]);
    //                     intrebari[i].raspunsuri[j].rezultate_evaluare.push(evaluariUnique[k].nume)

    //                 }







    //             }
    //         }







    //         console.log('intrebari :>> ', intrebari);

    //         let raportData = { completare: sesiuni.procent_completare, intrebari: intrebari, completare_color: sesiuni.color }

    //         let raport = {
    //             id_sesiune: sesiuni.id,
    //             titlu: '',
    //             la_data: this.u.updateSqlNow(),
    //             nr_evaluari: this.state.angajatiSelectati,
    //             finalizat_la_creare: sesiuni.finalizat === 1 ? 1 : 0,
    //             raport_data: JSON.stringify(raportData)

    //         }



    //         console.log('raport :>> ', raport);
    //         ///////INSERT RAPORT

    //         // let insertRaport = await this.ws.insert('rapoarte_salvate_head', raport)

    //         // console.log('insertRaport :>> ', insertRaport);

    //         // if (insertRaport.Succes) {

    //             raport.raport_data = JSON.parse(raport.raport_data)
    //             // raport.id = insertRaport.Content[0].id
    //             this.setState({
    //                 checkRaport: false,
    //                 popUpRaport: false,
    //                 openRaport: true,
    //                 raport: raport,
    //                 sesiuneSelectata: null
    //             }, () => {
    //                 this.getSesiuni()
    //             })
    //         // }

    //         ////insert succes



    //     // } else {
    //     //     console.log('s :>> ', s);
    //     //     this.setState({
    //     //         checkRaport: true,
    //     //         popUpRaport: true,
    //     //         sesiuneSelectata: s
    //     //     }, () => {
    //     //         window.scrollTo(0, 0)
    //     //     })
    //     // }



    // }


    selecteazaDepartament = (s, d) => {




        let sesiuni = [...this.state.sesiuni]


        let angajatiSelectati = this.state.angajatiSelectati


        for (let j = 0, m = sesiuni.length; j < m; j++) {
            let idxSubsesiuni = sesiuni[j].sub_sesiuni.findIndex(sub => sub.id === s.id)

            if (idxSubsesiuni !== -1) {
                let idxDepartamente = sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari.findIndex(dep => dep.id === d.id)

                if (idxDepartamente !== -1) {

                    sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente]['checked'] = !sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente]['checked']



                    for (let i = 0, n = sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari.length; i < n; i++) {


                        if (sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari[i]['checked'] !== sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente]['checked']) {
                            sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari[i]['checked'] = sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente]['checked']

                            if (sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari[i]['checked']) {
                                if (sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari[i]['checked']) {
                                    angajatiSelectati += 1
                                } else {
                                    angajatiSelectati -= 1
                                }
                            }
                        }

                    }

                }
            }
        }


        this.setState({
            sesiuni: sesiuni,
            angajatiSelectati: angajatiSelectati
        })
    }


    selecteazaEvaluare = (s, a) => {


        let sesiuni = [...this.state.sesiuni]

        let angajatiSelectati = this.state.angajatiSelectati


        for (let j = 0, m = sesiuni.length; j < m; j++) {
            let idxSubsesiuni = sesiuni[j].sub_sesiuni.findIndex(sub => sub.id === s.id)

            if (idxSubsesiuni !== -1) {
                // console.log(' :>> ', sesiuni[j].sub_sesiuni[idxSubsesiuni]);
                let idxDepartamente = sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari.findIndex(dep => dep.id === a.id_departament)

                if (idxDepartamente !== -1) {

                    let idxA = sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari.findIndex(ang => ang.id === a.id)

                    if (idxA !== -1) {
                        sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari[idxA]['checked'] = !sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari[idxA]['checked']
                        if (!sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari[idxA]['checked'] === false) {

                            angajatiSelectati += 1
                        } else {
                            angajatiSelectati -= 1
                            sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente]['checked'] = false

                        }

                        let filterDep = sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari.filter(ang => ang.checked)


                        // console.log('filterDep :>> ', filterDep);
                        if (sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente].evaluari.length === filterDep.length) {
                            sesiuni[j].sub_sesiuni[idxSubsesiuni].evaluari[idxDepartamente]['checked'] = true
                        }

                    }

                    this.setState({
                        angajatiSelectati: angajatiSelectati,
                        sesiuni: sesiuni
                    })

                }
            }
        }




    }

    raportTitluChange = (ev) => {
        let raport = { ...this.state.raport }

        raport['titlu'] = ev.target.value

        this.setState({ raport: raport })
    }

    updateTitluRaport = async () => {


        let updateRaport = await this.ws.update('rapoarte_salvate_head', { titlu: this.state.raport.titlu }, { id: this.state.raport.id })


        if (updateRaport.Succes) {
            this.getRapoarte()
        }
    }

    goToRaport = async (r) => {



        // console.log('r :>> ', r);

        let raport = { ...r }
        raport.raport_data = JSON.parse(raport.raport_data)

        // console.log('raport :>> ', raport);


        if (raport.raport_data.acelasi_chestionar) {

            let evaluariClone = [...raport.raport_data.evaluari]

            let evaluariUnique = []

            let departamente = raport.raport_data.departamente

            let useriSelectati = []


            for (let i = 0, n = departamente.length; i < n; i++) {

                for (let j = 0, m = departamente[i].angajati.length; j < m; j++) {
                    if (departamente[i].angajati[j].selectat) {
                        useriSelectati.push(departamente[i].angajati[j])
                    }
                }

            }



            for (let i = 0, n = evaluariClone.length; i < n; i++) {

                // if (evaluariClone[i].checked) {
                if (evaluariUnique.length > 0) {

                    let idx = evaluariUnique.findIndex(evl => evl.id_user_aprobare == evaluariClone[i].id_user_aprobare)

                    if (idx === -1) {



                        evaluariUnique.push(evaluariClone[i])
                    }

                } else {
                    evaluariUnique.push(evaluariClone[i])
                }
                // }



            }


            // console.warn('useriSelectati :>> ', useriSelectati);

            // console.log('raport.raport_data :>> ', raport.raport_data);
            this.setState({
                raport: raport,
                useri: evaluariUnique,
                openRaport: true,
                utilizatoriSelectati: useriSelectati,

            }, () => {
                this.raportChestionareG.current.filterRaport()
            })

        } else {
            this.setState({
                raport: raport,
                openRaport: true,

            }, () => {
                this.raportChestionareG.current.filterRaport()
            })
        }





    }

    stergeRaport = async () => {

        let sRaport = await this.ws.update('rapoarte_salvate_head', { sters: 1 }, { id: this.state.raport.id })

        if (sRaport.Succes) {

            this.setState({
                openDeleteRaport: false
            }, () => {

                this.getRapoarte()
            })
        }
    }

    openStergeRaport = (r) => {

        let raport = { ...r }

        raport.raport_data = JSON.parse(raport.raport_data)

        this.setState({
            openDeleteRaport: true,
            raport: raport
        })
    }

    openStergeEvaluare = (e) => {
        this.setState({
            openDeleteEvaluare: true,
            evaluareSelectata: e
        })
    }


    stergeEvaluare = async () => {

        let delEval = await this.ws.update('evaluari', { inactiv: 1 }, { id: this.state.evaluareSelectata.id })

        if (delEval.Succes) {



            this.setState({ openDeleteEvaluare: false }, () => {
                this.getSesiuni()
            })
        }
    }


    clearInputRaport = () => {

        this.setState({
            userEvaluat:


            {
                id: null, poza: null
            },
        })
    }

    selectUser = (u) => {


        let evaluariClone = [...this.state.useri]

        let idx = evaluariClone.findIndex(evl => evl.id_user_aprobare === u.id_user_aprobare)

        if (idx !== -1) {

            let userEvaluat = { id: evaluariClone[idx].id_user_aprobare, poza: evaluariClone[idx].poza, nume: evaluariClone[idx].nume }

            this.setState({
                userEvaluat: userEvaluat,

                checkRaport: false,
                popUpRaport: false,
                openRaport: true,
                raport: this.state.raport,
                sesiuneSelectata: null,
            }, () => {
                this.raportChestionareG.current.filterRaport()
            })
        }

    }


    selecteazaAngajat = (u) => {
        let raport = { ...this.state.raport }

        let departamente = raport.raport_data.departamente


        let idxDepartament = departamente.findIndex(dep => dep.id === u.id_departament)


        if (idxDepartament !== -1) {

            let idxUser = departamente[idxDepartament].angajati.findIndex(ang => ang.id === u.id)

            if (idxUser !== -1) {
                departamente[idxDepartament].angajati[idxUser].selectat = !departamente[idxDepartament].angajati[idxUser].selectat

                this.setState({ raport: raport })
            }
        }
        // console.log('u :>> ', u);
    }


    selecteazaDepartament = (d) => {

        let raport = { ...this.state.raport }

        let departamente = raport.raport_data.departamente


        let idxDepartament = departamente.findIndex(dep => dep.id === d.id)

        if (idxDepartament !== -1) {

            departamente[idxDepartament].selectat = !departamente[idxDepartament].selectat
            for (let i = 0, n = departamente[idxDepartament].angajati.length; i < n; i++) {
                departamente[idxDepartament].angajati[i].selectat = departamente[idxDepartament].selectat
            }


            this.setState({ raport: raport })
        }

    }


    salveazaUseriSiInchide = () => {

        let raport = { ...this.state.raport }

        let departamente = raport.raport_data.departamente

        let useriSelectati = []


        for (let i = 0, n = departamente.length; i < n; i++) {

            for (let j = 0, m = departamente[i].angajati.length; j < m; j++) {
                if (departamente[i].angajati[j].selectat) {
                    useriSelectati.push(departamente[i].angajati[j])
                }
            }

        }

        this.setState({ utilizatoriSelectati: useriSelectati }, () => {
            this.raportChestionareG.current.filterRaport()
        })

    }


    closeRaport = async () => {

        let raport = { ...this.state.raport }



        let updateRaport = await this.ws.update('rapoarte_salvate_head', { raport_data: JSON.stringify(raport.raport_data) }, { id: raport.id })

        // console.log('updateRaport :>> ', updateRaport);

        if (updateRaport.Succes) {
            this.setState({
                openRaport: false,
                raport: { id: null, raport_data: { evaluari: [], intrebari: [], departamente: [], sesiune: { sub_sesiuni: [] } } },
                utilizatoriSelectati: []
            }, () => {
                this.getRapoarte()
            })
        }
    }

    deleteUtilizatorSelectat = (u) => {

        let raport = { ...this.state.raport }

        let utilizatoriSelectati = [...this.state.utilizatoriSelectati]

        let departamente = raport.raport_data.departamente


        let idxDepartament = departamente.findIndex(dep => dep.id === u.id_departament)

        if (idxDepartament !== -1) {

            let idxUser = departamente[idxDepartament].angajati.findIndex(ang => ang.id === u.id)

            if (idxUser !== -1) {
                departamente[idxDepartament].angajati[idxUser].selectat = !departamente[idxDepartament].angajati[idxUser].selectat


            }
        }


        let idxUSelectat = utilizatoriSelectati.findIndex(us => us.id === u.id)


        if (idxUSelectat !== -1) {
            utilizatoriSelectati.splice(idxUSelectat, 1)

            this.setState({
                utilizatoriSelectati: utilizatoriSelectati,
                raport: raport
            }, () => {
                this.raportChestionareG.current.filterRaport()
            })
        }
    }


    finalizeazaSesiunea = async (s) => {

        let updateSes = await this.ws.update('sesiuni', { finalizat: 1 }, { id: s.id })

        if (updateSes.Succes) {
            this.getSesiuni()
        }
    }


    hidePopUpSesiune = (s) => {

        let sesiuni = [...this.state.sesiuni]

        let idx = sesiuni.findIndex(ses => ses.id === s.id)

        if (idx !== -1) {
            sesiuni[idx].pop_up = false

            this.setState({ sesiuni: sesiuni })
        }
    }


    openStergeSesiune = (s) => {
        this.setState({
            sesiuneToDelete: s,
            openDeleteSesiune: true
        })
    }


    deleteSesiune = async () => {


        let deleteSesiune = await this.ws.update('sesiuni', { sters: 1 }, { id: this.state.sesiuneToDelete.id })


        if (deleteSesiune.Succes) {

            this.setState({ openDeleteSesiune: false }, () => {

                this.getSesiuni()
            })
        }
    }

    startLoading = async () => {
        await this.setState({ loading: true })
    }


    render() {
        return (
            <div style={{ position: 'relative' }}>

                <CustomAppBar history={this.props.history} title={this.returnButton()} appBarButtons={this.buildAppBarButtons()} />


                <div className='loading-div' style={{ display: this.state.loading ? 'block' : 'none' }} >

                    <CircularProgress
                        style={{
                            width: 60,
                            height: 60,
                            color: '#25e048',
                            marginTop: '40%',

                        }}
                        value={20}

                    />
                    <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                </div>


                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />


                <AlertNew
                    open={this.state.openDeleteEvaluare}
                    dialogClose={() => { this.setState({ openDeleteEvaluare: false }) }}
                    title={this.dictionary.evaluari.alertStergeEvaluare}
                    mesaj={this.dictionary.evaluari.alertStergeEvaluareMessage}
                    yesFunction={this.stergeEvaluare}
                    deleteP={true}
                />

                <AlertNew
                    open={this.state.openDeleteRaport}
                    dialogClose={() => { this.setState({ openDeleteRaport: false }) }}
                    title={this.dictionary.evaluari.alertStergeRaport}
                    mesaj={this.dictionary.evaluari.alertStergeRaportMessage}
                    yesFunction={this.stergeRaport}
                    deleteP={true}
                />

                <RaportChestionareGeneral
                    open={this.state.openRaport}
                    dialogClose={this.closeRaport}
                    raport={this.state.raport}
                    raportTitluChange={this.raportTitluChange}
                    sesiune={this.state.sesiuneSelectata}
                    exportaRaport={this.exportaRaport}
                    updateTitluRaport={this.updateTitluRaport}
                    clearInput={this.clearInputRaport}
                    selectUser={this.selectUser}
                    useri={this.state.useri}
                    userEvaluat={this.state.userEvaluat}
                    ref={this.raportChestionareG}
                    utilizatoriSelectati={this.state.utilizatoriSelectati}
                    selecteazaAngajat={this.selecteazaAngajat}
                    selecteazaDepartament={this.selecteazaDepartament}
                    salveazaSiInchide={this.salveazaUseriSiInchide}
                    deleteUtilizatorSelectat={this.deleteUtilizatorSelectat}
                    startLoading={() => { this.setState({ loading: true }) }}
                    stopLoading={() => { this.setState({ loading: false }) }}
                />


                <AlertNew
                    open={this.state.openDeleteSesiune}
                    dialogClose={() => { this.setState({ openDeleteSesiune: false }) }}
                    title={this.dictionary.evaluari.alertStergeSesiune}
                    mesaj={this.dictionary.evaluari.alertStergeSesiuneMessage}
                    yesFunction={this.deleteSesiune}
                    deleteP={true}
                />

                {this.state.sesiuneNoua &&


                    <Grid style={{ maxWidth: 1200, margin: 'auto', marginBottom: 40 }} container >

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'> {this.dictionary.evaluari.evaluareGenerala} </h1>
                        </Grid>


                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, }}>


                                <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            id='chestionarNou'
                                            style={{ width: '97%' }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='titlu'
                                            value={this.state.titluSesiuneGenerala || ''}
                                            placeholder={this.dictionary.evaluari.titluSesiuneGenerala}
                                            onChange={(ev) => { this.setState({ titluSesiuneGenerala: ev.target.value }) }}
                                        />




                                        <label className='inputLabelPM' htmlFor='chestionarNou'> {this.dictionary.evaluari.sesiuneGenerala}</label>

                                    </div>
                                </Grid>


                                <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            id='chestionarNou'
                                            style={{ width: '90%' }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='titlu'
                                            value={this.state.titluSesiuneColegi || ''}
                                            placeholder={this.dictionary.evaluari.titluSesiuneColegi}
                                            onChange={(ev) => { this.setState({ titluSesiuneColegi: ev.target.value }) }}
                                        />




                                        <label className='inputLabelPM' htmlFor='chestionarNou'>{this.dictionary.evaluari.sesiuneColegi}</label>

                                    </div>
                                </Grid>

                                <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            id='chestionarNou'
                                            style={{ width: '90%' }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='titlu'
                                            value={this.state.titluSesiuneManager || ''}
                                            placeholder={this.dictionary.evaluari.titluSesiuneManager}
                                            onChange={(ev) => { this.setState({ titluSesiuneManager: ev.target.value }) }}
                                        />




                                        <label className='inputLabelPM' htmlFor='chestionarNou'>{this.dictionary.evaluari.sesiuneManager}</label>

                                    </div>
                                </Grid>

                                <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            id='chestionarNou'
                                            style={{ width: '90%' }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='titlu'
                                            value={this.state.titluSesiuneClienti || ''}
                                            placeholder={this.dictionary.evaluari.titluSesiuneClienti}
                                            onChange={(ev) => { this.setState({ titluSesiuneClienti: ev.target.value }) }}
                                        />




                                        <label className='inputLabelPM' htmlFor='chestionarNou'>{this.dictionary.evaluari.sesiuneClienti}</label>

                                    </div>
                                </Grid>



                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button className='add-button-green' onClick={this.addSesiune}  >
                                        <i className='material-icons pm-round-button-text'>add</i>
                                        {this.dictionary.evaluari.creeaza}
                                    </Button>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>

                }


                {!this.state.sesiuneNoua &&

                    <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                        <Grid style={{ margin: '80px 0 40px 0', textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h1 style={{ margin: 0, }} className='pm-title-big'> {this.dictionary.evaluari.evaluareGenerala} </h1>
                            <span style={{ fontSize: 14 }}>  {this.dictionary.evaluari.selecteazaSauCreeaza}</span>
                        </Grid>


                        {this.state.popUpGenerala && this.state.sesiuni.length === 0 &&
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <i style={{ fontSize: 18, verticalAlign: 'middle', display: 'flex' }} className='material-icons'>error</i>
                                        <span style={{ fontSize: 11, fontWeight: 500, display: 'flex' }}>
                                            <span>
                                                {this.dictionary.evaluari.mesajCreeazaEvaluareGenerala}

                                                <span style={{ textDecoration: 'underline' }}>{this.dictionary.evaluari.aici}.</span>
                                            </span>

                                        </span>
                                    </div>
                                    <div>
                                        <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} onClick={() => { this.setState({ popUpGenerala: false }) }} className='material-icons'>clear</i>
                                    </div>

                                </div>
                            </Grid>
                        }




                        {this.state.combinaEvaluari &&

                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id='evaluare_angajati'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='idColegi'
                                            value={this.state.idColegi}
                                            onChange={this.changeSesiuneColegi}
                                            placeholder={this.dictionary.evaluari.alegeOptiune}
                                        >

                                            <option value={0}>{this.dictionary.evaluari.alegeOptiune}</option>
                                            {this.state.sesiuniColegi.map((t, idx) => {
                                                return (
                                                    <option key={idx} value={t.id}>{t.nume}</option>
                                                )
                                            })}
                                        </select>
                                        <label style={{ marginLeft: 20 }} className='inputLabelPM' htmlFor='evaluare_angajati'>{this.dictionary.evaluari.sesiuneColegi}</label>
                                    </div>
                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id='evaluare_sefi'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='idSefi'
                                            value={this.state.idSefi}
                                            onChange={this.changeSesiuneSefi}
                                            placeholder={this.dictionary.evaluari.alegeOptiune}
                                        >

                                            <option value={0}>{this.dictionary.evaluari.alegeOptiune}</option>
                                            {this.state.sesiuniSefi.map((t, idx) => {
                                                return (
                                                    <option key={idx} value={t.id}>{t.nume}</option>
                                                )
                                            })}
                                        </select>
                                        <label style={{ marginLeft: 20 }} className='inputLabelPM' htmlFor='evaluare_sefi'>{this.dictionary.evaluari.sesiuneManager}</label>
                                    </div>
                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id='evaluare_clienti'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='idClienti'
                                            value={this.state.idClienti}
                                            onChange={this.changeSesiuneClienti}
                                            placeholder={this.dictionary.evaluari.alegeOptiune}
                                        >

                                            <option value={0}>{this.dictionary.evaluari.alegeOptiune}</option>
                                            {this.state.sesiuniClienti.map((t, idx) => {
                                                return (
                                                    <option key={idx} value={t.id}>{t.nume}</option>
                                                )
                                            })}
                                        </select>
                                        <label style={{ marginLeft: 20 }} className='inputLabelPM' htmlFor='evaluare_clienti'>{this.dictionary.evaluari.sesiuneClienti}</label>
                                    </div>
                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button disabled={!this.state.readySesiuneNoua} className='add-button-green' onClick={this.addSesiuneCombinata}  >

                                        {this.dictionary.evaluari.sesiuneGeneralaNoua}
                                    </Button>

                                    <Button className='add-button-green' style={{ marginLeft: 20 }} onClick={this.backCombinaEvaluari}  >

                                        {this.dictionary.evaluari.inapoi}
                                    </Button>
                                </Grid>


                            </Grid>

                        }




                        {this.state.sesiuni.length === 0 && !this.state.combinaEvaluari &&

                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 style={{ textAlign: 'left', fontWeight: 400 }}>{this.dictionary.evaluari.nuExistaSesiuneGenerala} </h5>
                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button className='add-button-green' onClick={() => { this.setState({ sesiuneNoua: true }) }}  >

                                        {this.dictionary.evaluari.sesiuneGeneralaNoua}
                                    </Button>

                                    {this.state.sesiuniClienti.length > 0 && this.state.sesiuniColegi.length > 0 && this.state.sesiuniSefi.length > 0 &&
                                        <Button className='add-button-green' style={{ marginLeft: 20 }} onClick={this.combinaEvaluari}  >

                                            {this.dictionary.evaluari.combinaEvaluariExistente}
                                        </Button>
                                    }


                                </Grid>


                            </Grid>


                        }

                        {this.state.sesiuneSelectata &&
                            <Grid style={{ backgroundColor: 'white', padding: 80, marginBottom: 20 }} container>


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <Grid container>
                                        <Grid style={{ textAlign: 'left', fontSize: 14 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                            <span> {this.dictionary.evaluari.sesiuneEvaluare}</span>

                                            <h4 style={{ textAlign: 'left', marginTop: 0, fontSize: 18 }} >{this.state.sesiuneSelectata.nume}</h4>

                                        </Grid>

                                        <Grid style={{ textAlign: 'right' }} item xs={6} sm={6} md={6} lg={6} xl={6} >
                                            <Button className='add-button-green' onClick={this.getSesiuni}  >

                                                {this.dictionary.evaluari.inapoi}
                                            </Button>
                                            <Button className='add-button-blue' style={{ marginLeft: 10 }} onClick={() => { this.getIntrebari(this.state.sesiuneSelectata) }}  >
                                                <ChartBarSolid className=' iconSvg' style={{ marginRight: 10, width: 18, height: 18 }} />
                                                {this.dictionary.evaluari.creeazaRaportGeneral}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>



                                <Divider style={{ width: '100%', marginBottom: 20 }} />




                                {this.state.checkRaport &&
                                    this.state.sesiuneSelectata.sub_sesiuni.map((s, idx2) => {
                                        return (
                                            <Grid key={idx2} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid className='container-sesiune' container>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        {s.tip === 'evaluare_angajati' &&

                                                            <h4 style={{ textAlign: 'center', marginTop: 0 }} >{this.dictionary.evaluari.evaluareColegi}</h4>
                                                        }

                                                        {s.tip === 'evaluare_sefi' &&
                                                            <h4 style={{ textAlign: 'center', marginTop: 0 }} >{this.dictionary.evaluari.evaluareManager} </h4>
                                                        }

                                                        {s.tip === 'evaluare_clienti' &&
                                                            <h4 style={{ textAlign: 'center', marginTop: 0 }} >{this.dictionary.evaluari.evaluareClienti}</h4>
                                                        }
                                                    </Grid>

                                                    <Grid style={{ marginTop: 20, textAlign: 'center', fontSize: 14 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <span>{this.dictionary.evaluari.scorTotal}</span>
                                                    </Grid>

                                                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <span className='procent-sesiune' style={{ color: s.color }}>{s.puncte}</span>
                                                    </Grid>

                                                    <Grid style={{ textAlign: 'center', fontSize: 12, marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                        <span>{this.dictionary.evaluari.finalizat}:<span style={{ fontWeight: 600, color: s.finalizat !== null ? 'rgb(24 165 58)' : 'red' }}>{s.finalizat !== null ? 'DA' : 'NU'}</span> </span>
                                                    </Grid>

                                                    <Grid style={{ textAlign: 'center', fontSize: 12, marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                        <span>{this.dictionary.evaluari.completare}:<span className='status-sesiune-evaluare' style={{ fontWeight: 600, color: s.color }}>{s.procent_completare}%</span> </span>
                                                    </Grid>

                                                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                        <Button className='add-button-blue' onClick={() => { this.goToSesiune(s) }}  >
                                                            <ChartBarSolid className=' iconSvg' style={{ marginRight: 10, width: 18, height: 18 }} />
                                                            {this.dictionary.evaluari.veziRaport}
                                                        </Button>
                                                    </Grid>

                                                </Grid>

                                                {this.state.checkRaport &&

                                                    <Divider style={{ width: '100%', marginTop: 20 }} />
                                                }


                                                <Grid container >

                                                    {s.evaluari.map((d, idx) => {
                                                        return (
                                                            <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Grid container>
                                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                                        <h4 style={{ textAlign: 'left', fontWeight: 400, paddingLeft: this.state.checkRaport ? 11 : 0 }}>
                                                                            {this.state.checkRaport &&
                                                                                <span >
                                                                                    {d.checked ?
                                                                                        <i onClick={() => { this.selecteazaDepartament(s, d) }} style={{ color: '#80cd5a' }} className='material-icons checkbox-departament' >check_box</i>
                                                                                        : <i onClick={() => { this.selecteazaDepartament(s, d) }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                                                                    }
                                                                                </span>
                                                                            }


                                                                            {this.dictionary.evaluari.departament}: {d.nume}</h4>
                                                                    </Grid>

                                                                    {d.evaluari.map((e, idx2) => {
                                                                        return (


                                                                            <Grid style={{ textAlign: 'left', marginBottom: 20, background: 'rgb(249,249,249)', padding: 10 }} key={idx2} container>



                                                                                <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                                                    {this.state.checkRaport &&
                                                                                        <span >
                                                                                            {e.checked ?
                                                                                                <i onClick={() => { this.selecteazaEvaluare(s, e) }} style={{ color: '#80cd5a' }} className='material-icons checkbox-departament' >check_box</i>
                                                                                                : <i onClick={() => { this.selecteazaEvaluare(s, e) }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                                                                            }
                                                                                        </span>
                                                                                    }


                                                                                    {e.poza &&
                                                                                        <div
                                                                                            className='pm-angajati-picture'
                                                                                            style={{ backgroundImage: `url('${this.wsP.adresaMedia + '/Angajati/' + e.poza}')`, width: 36, height: 36, padding: 5 }}>

                                                                                        </div>
                                                                                    }
                                                                                    {!e.poza &&

                                                                                        <Avatar
                                                                                            className='pm-angajati-picture'
                                                                                            style={{ display: 'inline-block', textAlign: 'center', height: 36, width: 36, backgroundColor: this.u.culoriUtilizatori(e.id), padding: 5, cursor: 'pointer' }}>
                                                                                            <i style={{ verticalAlign: 'middle' }} className='material-icons'>person</i>
                                                                                        </Avatar>
                                                                                    }
                                                                                </Grid>


                                                                                <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                                                                    <Grid container>

                                                                                        <Grid style={{ paddingTop: 5 }} item xs={5} sm={5} md={5} lg={5} xl={5}>
                                                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, marginLeft: 10 }}>{e.nume}</span>
                                                                                            <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', marginLeft: 10 }}>{e.functie}</span>

                                                                                        </Grid>
                                                                                        <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                                                            {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                                            <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.data}</span>
                                                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600 }}>{this.u.ParseDataFromSql(e.cand_creat)}</span>

                                                                                        </Grid>

                                                                                        <Grid style={{ textAlign: 'left' }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                                                            {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                                            <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.evaluatori}</span>
                                                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600 }}>{e.completari_toate}</span>


                                                                                        </Grid>
                                                                                        <Grid style={{ textAlign: 'left', paddingLeft: 10 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                                                            {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                                            <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.completareNoCaps}</span>
                                                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600 }}>{e.procent_completare}%</span>


                                                                                        </Grid>
                                                                                        <Grid style={{ textAlign: 'left' }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                                                            {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                                            <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.puncte}</span>
                                                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: e.color_puncte }}>{e.puncte}</span>


                                                                                        </Grid>


                                                                                        {/* {!this.state.sesiuneSelectata.finalizat &&
                                                                    <Grid style={{
                                                                        justifyContent: 'flex-end',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                        <TrashAltSolid className=' iconSvg' onClick={() => { this.openStergeEvaluare(e) }} style={{ marginRight: 0, width: 18, height: 18 }} />
                                                                        <EyeSolid className=' iconSvg' onClick={() => { this.goToEvaluare(s, e) }} style={{ marginLeft: 10, width: 18, height: 18 }} />

                                                                     
                                                                    </Grid>
                                                                }


                                                                {this.state.sesiuneSelectata.finalizat &&
                                                                    <Grid style={{
                                                                        justifyContent: 'flex-end',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                        <TrashAltSolid className=' iconSvg' style={{ marginRight: 0, width: 18, height: 18, color: 'gray' }} />
                                                                        <EyeSolid onClick={() => { this.goToEvaluare(s, e) }} className=' iconSvg' style={{ marginLeft: 10, width: 18, height: 18, color: 'gray' }} />

                                                                       
                                                                    </Grid>
                                                                } */}



                                                                                    </Grid>

                                                                                </Grid>



                                                                            </Grid>
                                                                        )
                                                                    })}
                                                                </Grid>
                                                            </Grid>
                                                        )

                                                    })}

                                                </Grid>

                                            </Grid>
                                        )

                                    })}





                                <Divider style={{ width: '100%', marginTop: 20 }} />

                            </Grid>
                        }


                        {!this.state.sesiuneSelectata && this.state.sesiuni.length > 0 && !this.state.combinaEvaluari && this.state.sesiuni.map((r, idx) => {

                            return (
                                <Grid style={{ backgroundColor: 'white', padding: 80, marginBottom: 20, position: 'relative' }} key={idx} container>


                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        <Grid container>
                                            <Grid style={{ textAlign: 'left', fontSize: 14 }} item xs={5} sm={5} md={5} lg={5} xl={5}>
                                                <span>{this.dictionary.evaluari.sesiuneEvaluare}</span>

                                                <h4 style={{ textAlign: 'left', marginTop: 0, fontSize: 18 }} >{r.nume}</h4>

                                            </Grid>

                                            <Grid style={{ textAlign: 'right' }} item xs={7} sm={7} md={7} lg={7} xl={7} >
                                                <Button className='add-button-blue' style={{ marginRight: 20 }} onClick={() => { this.getIntrebari(r) }}  >
                                                    <ChartBarSolid className=' iconSvg' style={{ marginRight: 10, width: 18, height: 18 }} />
                                                    {this.dictionary.evaluari.creeazaRaportGeneral}
                                                </Button>

                                                {r.finalizat !== 1 &&
                                                    <Button className='add-button-red' onClick={() => { this.finalizeazaSesiunea(r) }}  >

                                                        {this.dictionary.evaluari.finalizeazaSesiunea}
                                                    </Button>
                                                }


                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {r.pop_up &&
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <i style={{ fontSize: 18, verticalAlign: 'middle', display: 'flex' }} className='material-icons'>error</i>
                                                    <span style={{ fontSize: 11, fontWeight: 500, display: 'flex' }}>
                                                        <span>

                                                        </span>
                                                        {this.dictionary.evaluari.sesiuneChestionareDiferite}
                                                    </span>
                                                </div>
                                                <div>
                                                    <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} onClick={() => this.hidePopUpSesiune(r)} className='material-icons'>clear</i>
                                                </div>

                                            </div>
                                        </Grid>
                                    }






                                    <Divider style={{ width: '100%', marginBottom: 20 }} />


                                    {!this.state.checkRaport &&
                                        r.sub_sesiuni.map((s, idx2) => {
                                            return (
                                                <Grid style={{ borderRight: r.sub_sesiuni.length - 1 > idx2 ? '1px solid #e0e0e0' : '' }} key={idx2} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                    <Grid className='container-sesiune' container>

                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            {s.tip === 'evaluare_angajati' &&

                                                                <h4 style={{ textAlign: 'center', marginTop: 0 }} > {this.dictionary.evaluari.evaluareColegi}</h4>
                                                            }

                                                            {s.tip === 'evaluare_sefi' &&
                                                                <h4 style={{ textAlign: 'center', marginTop: 0 }} >{this.dictionary.evaluari.evaluareManager}</h4>
                                                            }

                                                            {s.tip === 'evaluare_clienti' &&
                                                                <h4 style={{ textAlign: 'center', marginTop: 0 }} >{this.dictionary.evaluari.evaluareClienti}</h4>
                                                            }
                                                        </Grid>

                                                        <Grid style={{ marginTop: 20, textAlign: 'center', fontSize: 14 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <span>{this.dictionary.evaluari.scorTotal}</span>
                                                        </Grid>

                                                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <span className='procent-sesiune' style={{ color: s.color }}>{s.puncte}</span>
                                                        </Grid>

                                                        <Grid style={{ textAlign: 'center', fontSize: 12, marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <span>{this.dictionary.evaluari.finalizat}:<span style={{ fontWeight: 600, color: s.finalizat !== null ? 'rgb(24 165 58)' : 'red' }}>{s.finalizat !== null ? 'DA' : 'NU'}</span> </span>
                                                        </Grid>

                                                        <Grid style={{ textAlign: 'center', fontSize: 12, marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <span>{this.dictionary.evaluari.completare}:<span className='status-sesiune-evaluare' style={{ fontWeight: 600, color: s.color }}>{s.procent_completare}%</span> </span>
                                                        </Grid>

                                                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                            <Button className='add-button-blue' style={{ marginTop: 20 }} onClick={() => { this.goToSesiune(s) }}  >
                                                                <ChartBarSolid className=' iconSvg' style={{ marginRight: 10, width: 18, height: 18 }} />
                                                                Vezi Raport
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })
                                    }



                                    <Divider style={{ width: '100%', marginTop: 20 }} />

                                    {r.rapoarte.length > 0 &&
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <h4 style={{ textAlign: 'left', marginTop: 20 }} >{this.dictionary.evaluari.rapoarteSalvate}</h4>
                                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                                                {r.rapoarte.map((rap, idx) => {
                                                    return (
                                                        <Grid style={{ textAlign: 'left', marginBottom: 20, background: 'rgb(249,249,249)', padding: 10 }} key={idx} container>
                                                            <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                                <ChartBarSolid onClick={() => { this.setState({ openSettings: this.state.openSettings ? false : true }) }} className='iconSvg' style={{ verticalAlign: 'bottom', cursor: 'pointer' }} />


                                                            </Grid>


                                                            <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                                                <Grid container>
                                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{rap.titlu}</span>
                                                                        <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', }}>{rap.nr_evaluari} persoane</span>

                                                                    </Grid>
                                                                    <Grid style={{ textAlign: 'left' }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                                                        {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                        <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.data}</span>
                                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.ParseDataFromSql(rap.la_data)}</span>


                                                                    </Grid>

                                                                    <Grid style={{
                                                                        justifyContent: 'flex-end',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }} item xs={5} sm={5} md={5} lg={5} xl={5}>
                                                                        <TrashAltSolid className=' iconSvg' onClick={() => { this.openStergeRaport(rap) }} style={{ marginRight: 0, width: 18, height: 18 }} />
                                                                        <EyeSolid className=' iconSvg' onClick={() => { this.goToRaport(rap) }} style={{ marginLeft: 10, width: 18, height: 18 }} />

                                                                        {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    )

                                                })}
                                            </Grid>

                                        </Grid>
                                    }


                                    <div className='delete-sesiune'>
                                        <TrashAltSolid onClick={() => { this.openStergeSesiune(r) }} style={{ marginRight: 0, width: 18, height: 18, color: 'rgb(252 62 70)' }} />
                                    </div>

                                </Grid>

                            )
                        })}

                        {this.state.sesiuni.length > 0 && !this.state.combinaEvaluari &&
                            < Grid style={{ textAlign: 'left', marginBottom: 40 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Button style={{ marginRight: 20 }} className='add-button-green' onClick={() => { this.setState({ sesiuneNoua: true }) }}  >

                                    {this.dictionary.evaluari.sesiuneNoua}
                                </Button>

                                {this.state.sesiuniClienti.length > 0 && this.state.sesiuniColegi.length > 0 && this.state.sesiuniSefi.length > 0 &&
                                    <Button className='add-button-green' onClick={this.combinaEvaluari}  >

                                        {this.dictionary.evaluari.combinaEvaluariExistente}
                                    </Button>
                                }
                            </Grid>
                        }



                        {this.state.popUpSalvare &&

                            <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(254 193 53)', borderRadius: 30, padding: 10, marginBottom: 20, marginTop: 20, textAlign: 'left', width: '100%' }}>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i> <span style={{ fontSize: 11, fontWeight: 500 }}>
                                        {this.dictionary.evaluari.nuAiChestionarSalvatSistem} <span onClick={this.goToChestionare} style={{ textDecoration: 'underline', cursor: 'pointer' }}>{this.dictionary.evaluari.clickAici}</span> {this.dictionary.evaluari.pentruACreaUnChestionarAcum}</span>
                                </div>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} onClick={() => { this.setState({ popUpSalvare: false }) }} className='material-icons'>clear</i>
                                </div>

                            </div>
                        }

                    </Grid>

                }


            </div >
        );
    }
}